import {
  RenderPage,
  updateRendererFormState,
} from "../../../slices/common/reducer";
import {
  setWhiteListedData,
  setWhiteListedEdit,
} from "../../../slices/IpSettings/ipSettingsSlice";
import rootReducer from "../../../store";
import api from "../../../Utils/interface";

export const createIpSettings = async (body) => {
  const data = JSON.stringify(body);

  try {
    const response = await api.post(`/ip-config/create`, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.data && response.status === 200) {
      rootReducer.dispatch(RenderPage());
      return response.data;
    }
  } catch (error) {
    console.log("Error", error);
  }
};

export const readIpSettings = async (body, page, size) => {
  const data = JSON.stringify(body);

  try {
    const response = await api.post(
      `/ip-config/read?$page=${page}&$size=${size}`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    if (response.data) {
      rootReducer.dispatch(setWhiteListedData(response.data));
      rootReducer.dispatch(RenderPage());

      // rootReducer.dispatch(update(response.data));
    }
  } catch (error) {
    console.log("Error", error);
  }
};

export const readIpSettingsbyId = async (id) => {
  try {
    const response = await api.post(`/ip-config/read/${id}`);
    if (response.data) {
      rootReducer.dispatch(updateRendererFormState(response.data));

      // rootReducer.dispatch(update(response.data));
    }
  } catch (error) {
    console.log("Error", error);
  }
};

export const updateIpSettings = async (body, id) => {
  const data = JSON.stringify(body);

  try {
    const response = await api.post(`/ip-config/update/${id}`, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.data) {
      rootReducer.dispatch(RenderPage());

      return response.data;
    }
  } catch (error) {
    console.log("Error", error);
  }
};

export const getAllMappedUser = async () => {
  try {
    const response = await api.get(`/agsp/getAllAgspUser`, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.log("error in getting mapped users", error);
  }
};
